// extracted by mini-css-extract-plugin
export var promotionLink = "_v6-0";